// extracted by mini-css-extract-plugin
module.exports = {"accordionTitle":"MobileHeader_accordionTitle__UBV21","searchContainer":"MobileHeader_searchContainer__WUeVl","menuContainer":"MobileHeader_menuContainer__oAVaC"};